/* tslint:disable */
/**
 * This file was automatically generated by data-schemas/src/generate-event-types.ts.
 * DO NOT MODIFY IT BY HAND. Instead, modify the respective JSON schemas or the generate-event-types.ts file,
 * and run `pnpm generate-event-types` to regenerate this file.
 */

import { ExperimentAssignmentsRawEvent } from "./experiment_assignments_raw_event";
import { SearchTrackingEvent } from "./search_tracking_event";
import { SearchTrackingRawEvent } from "./search_tracking_raw_event";
import { AppleUsersEvent } from "./apple_users_event";
import { ClassPageImpression } from "./class_page_impression";
import { ClassSearch } from "./class_search";
import { ClassWalletSetupRequest } from "./class_wallet_setup_request";
import { EnrollmentPaymentDisbursal } from "./enrollment_payment_disbursal";
import { ExperimentAssignmentsEvent } from "./experiment_assignments_event";
import { FacebookUsersEvent } from "./facebook_users_event";
import { GoogleUsersEvent } from "./google_users_event";
import { MobileEvent } from "./mobile_event";
import { NavigateToClassWalletToRequestOrder } from "./navigate_to_class_wallet_to_request_order";
import { OidcUsers } from "./oidc_users";
import { OneOnOneRecurringPaymentStopped } from "./one_on_one_recurring_payment_stopped";
import { ProductAdded } from "./product_added";
import { SectionAssigned } from "./section_assigned";
import { LearnerTrackingEvent } from "./learner_tracking_event";
import { LearnerTrackingEventRaw } from "./learner_tracking_event_raw";
import { TrustOsEvent } from "./trust_os_event";

export { ExperimentAssignmentsRawEvent };
export { SearchTrackingEvent };
export { SearchTrackingRawEvent };
export { AppleUsersEvent };
export { ClassPageImpression };
export { ClassSearch };
export { ClassWalletSetupRequest };
export { EnrollmentPaymentDisbursal };
export { ExperimentAssignmentsEvent };
export { FacebookUsersEvent };
export { GoogleUsersEvent };
export { MobileEvent };
export { NavigateToClassWalletToRequestOrder };
export { OidcUsers };
export { OneOnOneRecurringPaymentStopped };
export { ProductAdded };
export { SectionAssigned };
export { LearnerTrackingEvent };
export { LearnerTrackingEventRaw };
export { TrustOsEvent };

export enum EventNames {
  ExperimentAssignmentsRawEvent = "experiment_assignments_raw_event",
  SearchTrackingEvent = "search_tracking_event",
  SearchTrackingRawEvent = "search_tracking_raw_event",
  AppleUsersEvent = "apple_users_event",
  ClassPageImpression = "class_page_impression",
  ClassSearch = "class_search",
  ClassWalletSetupRequest = "class_wallet_setup_request",
  EnrollmentPaymentDisbursal = "enrollment_payment_disbursal",
  ExperimentAssignmentsEvent = "experiment_assignments_event",
  FacebookUsersEvent = "facebook_users_event",
  GoogleUsersEvent = "google_users_event",
  MobileEvent = "mobile_event",
  NavigateToClassWalletToRequestOrder = "navigate_to_class_wallet_to_request_order",
  OidcUsers = "oidc_users",
  OneOnOneRecurringPaymentStopped = "one_on_one_recurring_payment_stopped",
  ProductAdded = "product_added",
  SectionAssigned = "section_assigned",
  LearnerTrackingEvent = "learner_tracking_event",
  LearnerTrackingEventRaw = "learner_tracking_event_raw",
  TrustOsEvent = "trust_os_event",
}

export type EventSchemas =
  | ExperimentAssignmentsRawEvent
  | SearchTrackingEvent
  | SearchTrackingRawEvent
  | AppleUsersEvent
  | ClassPageImpression
  | ClassSearch
  | ClassWalletSetupRequest
  | EnrollmentPaymentDisbursal
  | ExperimentAssignmentsEvent
  | FacebookUsersEvent
  | GoogleUsersEvent
  | MobileEvent
  | NavigateToClassWalletToRequestOrder
  | OidcUsers
  | OneOnOneRecurringPaymentStopped
  | ProductAdded
  | SectionAssigned
  | LearnerTrackingEvent
  | LearnerTrackingEventRaw
  | TrustOsEvent;

export type Events =
  | {
      event: "experiment_assignments_raw_event";
      data: ExperimentAssignmentsRawEvent;
    }
  | {
      event: "search_tracking_event";
      data: SearchTrackingEvent;
    }
  | {
      event: "search_tracking_raw_event";
      data: SearchTrackingRawEvent;
    }
  | {
      event: "apple_users_event";
      data: AppleUsersEvent;
    }
  | {
      event: "class_page_impression";
      data: ClassPageImpression;
    }
  | {
      event: "class_search";
      data: ClassSearch;
    }
  | {
      event: "class_wallet_setup_request";
      data: ClassWalletSetupRequest;
    }
  | {
      event: "enrollment_payment_disbursal";
      data: EnrollmentPaymentDisbursal;
    }
  | {
      event: "experiment_assignments_event";
      data: ExperimentAssignmentsEvent;
    }
  | {
      event: "facebook_users_event";
      data: FacebookUsersEvent;
    }
  | {
      event: "google_users_event";
      data: GoogleUsersEvent;
    }
  | {
      event: "mobile_event";
      data: MobileEvent;
    }
  | {
      event: "navigate_to_class_wallet_to_request_order";
      data: NavigateToClassWalletToRequestOrder;
    }
  | {
      event: "oidc_users";
      data: OidcUsers;
    }
  | {
      event: "one_on_one_recurring_payment_stopped";
      data: OneOnOneRecurringPaymentStopped;
    }
  | {
      event: "product_added";
      data: ProductAdded;
    }
  | {
      event: "section_assigned";
      data: SectionAssigned;
    }
  | {
      event: "learner_tracking_event";
      data: LearnerTrackingEvent;
    }
  | {
      event: "learner_tracking_event_raw";
      data: LearnerTrackingEventRaw;
    }
  | {
      event: "trust_os_event";
      data: TrustOsEvent;
    };
